import type { Slot } from './types'

export type Period = 'morning' | 'afternoon' | 'evening'
export interface FormattedSlot {
  timeIso: string
  label: string
  available: boolean
}
export interface SlotGroup {
  period: Period
  slots: FormattedSlot[]
}

/** Hora local 12h, ej. "8:00 PM", en la tz de la location. */
export function formatSlotTime(timeIso: string, tz: string): string {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(new Date(timeIso))
}

/** Hora local 0-23 del slot en la tz, para decidir la franja. */
function localHour(timeIso: string, tz: string): number {
  const h = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    hour: 'numeric',
    hour12: false,
  }).format(new Date(timeIso))
  return Number(h) % 24
}

const ORDER: Period[] = ['morning', 'afternoon', 'evening']

/** Agrupa los slots por franja del día (mañana/tarde/noche) en la tz de la
 *  location, conservando el estado `available` y formateando la hora local.
 *  Omite franjas vacías. */
export function groupSlotsByPeriod(slots: Slot[], tz: string): SlotGroup[] {
  const buckets: Record<Period, FormattedSlot[]> = { morning: [], afternoon: [], evening: [] }
  for (const s of slots) {
    const h = localHour(s.timeIso, tz)
    const period: Period = h < 12 ? 'morning' : h < 17 ? 'afternoon' : 'evening'
    buckets[period].push({ timeIso: s.timeIso, label: formatSlotTime(s.timeIso, tz), available: s.available })
  }
  return ORDER.filter((p) => buckets[p].length > 0).map((p) => ({ period: p, slots: buckets[p] }))
}

export function hasAnyAvailable(slots: Slot[]): boolean {
  return slots.some((s) => s.available)
}
